/*
 * В макете тостов нет вообще (грепом по слову «toast» — 0 совпадений). Позиция и стопка —
 * Step 4 брифа («правый нижний угол, стопка»); отступы от края (20px) и ширина (342px)
 * спроектированы, а не перенесены — ширина взята равной уже существующей ширине поповера
 * уведомлений (prototype/Prototype.dc.html:182, `width:342px`) ради согласованности чисел,
 * а не скопирована с тоста, которого в макете нет.
 */
.viewport {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 342px;
  max-width: calc(100vw - 32px);
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
}

/* Вид — Step 4 брифа буквально: --panel/--line/radius 12/shadow-pop/полоса 3px по типу. */
.root {
  position: relative;
  background: var(--panel);
  border: 1px solid var(--line);
  border-left-width: 3px;
  border-radius: 12px;
  box-shadow: var(--shadow-pop);
  padding: 11px 13px;
}

.root[data-tone='error'] {
  border-left-color: var(--st-cancel);
}
.root[data-tone='success'] {
  border-left-color: var(--st-in);
}

.root[data-state='open'] {
  animation: 0.24s var(--ease-out) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(pop-in);
}

.root:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.body {
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.description {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ink-3);
}

.meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
}

.requestId {
  overflow: hidden;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  color: var(--ink-4);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.copy {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--accent);
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.copy:hover {
  color: var(--ink);
}

.close {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin: -2px -2px 0 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--ink-4);
  cursor: pointer;
}
.close:hover {
  background: var(--sunk);
  color: var(--ink);
}
